function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "27.24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2710",
  "data-name": "Path 2710",
  d: "M38.5 4.5v12.887H25.9v8.353H4.5V12.853h12.6V4.5zm3-3H14.1v8.353H1.5V28.74h27.4v-8.353h12.6z",
  transform: "translate(-1.5 -1.5)",
  fill: "#fff"
})));